// extracted by mini-css-extract-plugin
export default {"clientNameContainer":"style_clientNameContainer__okJ2n"};